import React from "react";
import { Card, Typography, Row, Col, Tag, Space, Button } from "antd";
import { EyeFilled, SettingOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useGetTestToken } from "Pages/DRS/Context/MyBatchContext";
import { ToastContextDispatch } from "Context/CommonContext";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
import CustomModal from "Components/CommonComponents/CustomModal";
const { Text } = Typography;

const StyledCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  margin-bottom: 24px;
`;

const ConfigItem = styled.div`
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`;

interface ConfigProps {
  subject: string;
  duration: string;
  format: string;
  mode: string;
  totalMarks: number;
  testId: number;
  externalTestScheduleId: number;
}

const TestConfiguration: React.FC<ConfigProps> = ({
  subject,
  duration,
  format,
  mode,
  totalMarks,
  testId,
  externalTestScheduleId,
}) => {
  const [model, setModel] = React.useState<boolean>(false);
  const [pdfUrl, setPdfUrl] = React.useState<string>("");
  const ToastDispatch = React.useContext(ToastContextDispatch);

  const { fetchToken, loading } = useGetTestToken((response: any) => {
    const { data } = response || {};
    const { pdfUrl: url } = data || {};
    if (url) {
      setPdfUrl(url);
      setModel(true);
    }
    if (response["code"] == "NF") {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: response["message"],
      });
    }
  });
  return (
    <StyledCard
      title={
        <Space>
          <SettingOutlined style={{ color: "#1890ff" }} />
          <span>Test Configuration</span>
        </Space>
      }
    >
      <CustomModal
        width="100vw"
        fullscreen={true}
        className="document-viewer-fullscreen-modal"
        title="Test PDF"
        modal={model}
        centered={true}
        backdrop={true}
        toggle={() => {
          setModel(false);
          setPdfUrl("");
        }}
        footer={null}
        destroyOnClose={true}
      >
        {pdfUrl && (
          <div
            className="modern-asset-viewer-container w-100 d-flex align-items-center justify-content-center"
            style={{
              height: "100vh",
              maxHeight: "100vh",
              overflow: "hidden",
              background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
              padding: "0",
            }}
          >
            <PDFPageviewer
              pdfUrl={pdfUrl}
              allPageInOne={true}
              isLibraryView={true}
              parentComponent="ChannelAttachments"
            />
          </div>
        )}
      </CustomModal>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <ConfigItem>
            <Text
              type="secondary"
              style={{ fontSize: "12px", display: "block" }}
            >
              Subject
            </Text>
            <Text strong style={{ fontSize: "16px" }}>
              {subject}
            </Text>
          </ConfigItem>
        </Col>
        <Col span={12}>
          <ConfigItem>
            <Text
              type="secondary"
              style={{ fontSize: "12px", display: "block" }}
            >
              Duration
            </Text>
            <Text strong style={{ fontSize: "16px" }}>
              {duration} Minutes
            </Text>
          </ConfigItem>
        </Col>
        <Col span={12}>
          <ConfigItem>
            <Text
              type="secondary"
              style={{ fontSize: "12px", display: "block" }}
            >
              Format | Mode
            </Text>
            <Tag color="blue" style={{ marginTop: 4, borderRadius: 16 }}>
              {format} | {mode}
            </Tag>
          </ConfigItem>
        </Col>
        <Col span={12}>
          <ConfigItem>
            <Text
              type="secondary"
              style={{ fontSize: "12px", display: "block" }}
            >
              Total Marks
            </Text>
            <Text strong style={{ fontSize: "16px" }}>
              {totalMarks} Marks
            </Text>
          </ConfigItem>
        </Col>
        <Col span={24}>
          <Button
            icon={<EyeFilled />}
            style={{ width: "100%" }}
            size="large"
            type="primary"
            loading={loading}
            onClick={() => fetchToken(externalTestScheduleId, testId)}
          >
            View Test Paper
          </Button>
        </Col>
      </Row>
    </StyledCard>
  );
};

export default TestConfiguration;
